import { useState } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import PlatformView from "./PlatformView";
import TranslationCsvActions from "./components/TranslationCsvActions";

export function Translations() {
  const [selectedTab, setSelectedTab] = useState(0);
  const [refreshKey, setRefreshKey] = useState(0);
  const platform = selectedTab === 1 ? "kiosk" : "web";

  return (
    <div className="container-main">
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
        }}
      >
        <Tabs value={selectedTab} onChange={(_, v) => setSelectedTab(v)}>
          <Tab label="Web app" />
          <Tab label="Kiosk app" />
        </Tabs>
        <TranslationCsvActions
          platform={platform}
          onImported={() => setRefreshKey((current) => current + 1)}
          sx={{ mb: 0 }}
        />
      </Box>

      <PlatformView platform={platform} refreshKey={refreshKey} />
    </div>
  );
}

export default Translations;
